var map = {
	"./admin/admin-panel.js": "./src_d1/admin/admin-panel.js",
	"./admin/test-map.js": "./src_d1/admin/test-map.js",
	"./demo/demo-panel.js": "./src_d1/demo/demo-panel.js",
	"./demo/detections.js": "./src_d1/demo/detections.js",
	"./demo/list-stelles.js": "./src_d1/demo/list-stelles.js",
	"./demo/overview.js": "./src_d1/demo/overview.js",
	"./demo/polls-overview.js": "./src_d1/demo/polls-overview.js",
	"./demo/pres/pres-stat.js": "./src_d1/demo/pres/pres-stat.js",
	"./demo/pres/presentation.js": "./src_d1/demo/pres/presentation.js",
	"./demo/stat/stat-emotion-map.js": "./src_d1/demo/stat/stat-emotion-map.js",
	"./demo/stat/stat-emotion.js": "./src_d1/demo/stat/stat-emotion.js",
	"./demo/stat/stat-person.js": "./src_d1/demo/stat/stat-person.js",
	"./demo/stat/stat-persons.js": "./src_d1/demo/stat/stat-persons.js",
	"./demo/stat/stat-stella.js": "./src_d1/demo/stat/stat-stella.js",
	"./demo/stat/stat-stellas.js": "./src_d1/demo/stat/stat-stellas.js",
	"./demo/stat/stats.js": "./src_d1/demo/stat/stats.js",
	"./demo/сomparison.js": "./src_d1/demo/сomparison.js",
	"./general/change-pass.js": "./src_d1/general/change-pass.js",
	"./general/change-phone.js": "./src_d1/general/change-phone.js",
	"./general/default-panel.js": "./src_d1/general/default-panel.js",
	"./general/main.js": "./src_d1/general/main.js",
	"./general/notice/fire-notice.js": "./src_d1/general/notice/fire-notice.js",
	"./general/notice/notice-types/Service.js": "./src_d1/general/notice/notice-types/Service.js",
	"./general/notice/notice-types/notice.js": "./src_d1/general/notice/notice-types/notice.js",
	"./general/notice/notices.js": "./src_d1/general/notice/notices.js",
	"./general/profile.js": "./src_d1/general/profile.js",
	"./guest/poll-end.js": "./src_d1/guest/poll-end.js",
	"./guest/poll-questions.js": "./src_d1/guest/poll-questions.js",
	"./guest/polls.js": "./src_d1/guest/polls.js",
	"./guest/sign-in.js": "./src_d1/guest/sign-in.js",
	"./index.js": "./src_d1/index.js",
	"./models/detection.js": "./src_d1/models/detection.js",
	"./models/district.js": "./src_d1/models/district.js",
	"./models/districtEmotion.js": "./src_d1/models/districtEmotion.js",
	"./models/server_va.js": "./src_d1/models/server_va.js",
	"./models/user.js": "./src_d1/models/user.js",
	"./operator/operator-panel.js": "./src_d1/operator/operator-panel.js",
	"./operator/stellas.js": "./src_d1/operator/stellas.js",
	"./panel.js": "./src_d1/panel.js",
	"./stele.js": "./src_d1/stele.js",
	"./widgets/dateDiapasonWithPreset.js": "./src_d1/widgets/dateDiapasonWithPreset.js",
	"./widgets/detection.js": "./src_d1/widgets/detection.js",
	"./widgets/personDetection.js": "./src_d1/widgets/personDetection.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src_d1 sync recursive ^(.*\\.(js$))[^.]*$/i";